import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useLazyGetApplicationIDsByAiSearchQuery, useLazyGetApplicationIDsByJobIdQuery } from '../../../modules/createJob/slice/candiddateApiSlice';
import { selectActiveTabFilterIndex, selectAiFilters, selectAiFiltersArray, selectCandidateProfile, selectCandidatesFilters, setCandidatesFilter } from '../../../modules/createJob/slice/candidateSlice';
import { setActiveTab } from '../../../modules/createJob/slice/jobSlice';
import { IAIFilter } from '../interfaces/candidatesListFace';

export const useCandidateNavigation = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const aiFiltersArray: { id: number, question: string }[] = useSelector(selectAiFiltersArray);
    const { jobId } = useParams();
    const activeSearchTabIndex = useSelector(selectActiveTabFilterIndex);
    const candidatesFilter = useSelector(selectCandidatesFilters);
    const candidatesAiFilter: IAIFilter = useSelector(selectAiFilters);
    const candidate = useSelector(selectCandidateProfile)

    const [getAiIds, { isSuccess: isAiIdsSuccess, data: aiIdsData }] = useLazyGetApplicationIDsByAiSearchQuery()
    const [getIds, { isSuccess: isIdsSuccess, data: idsData }] = useLazyGetApplicationIDsByJobIdQuery()

    useEffect(() => {
        if (isIdsSuccess) {
            localStorage.setItem("candidatesIds", JSON.stringify(idsData?.data));
        }
    }, [isIdsSuccess, idsData]);

    useEffect(() => {
        if (isAiIdsSuccess) {
            localStorage.setItem("candidatesIds", JSON.stringify(aiIdsData?.data));
        }
    }, [isAiIdsSuccess, aiIdsData]);

    const getUpdatedCandidatesIds = async () => {
        if (aiFiltersArray?.length) {
            await getAiIds({ jobId, query: aiFiltersArray[activeSearchTabIndex - 1]?.question, ...candidatesAiFilter, hiringStageId: candidate?.pipelineHiringStageId });
        } else await getIds({ jobId, ...candidatesFilter });
    }

    const handleCandidateNavigate = async () => {
        const candidatesIds = JSON.parse(localStorage.getItem('candidatesIds') || '[]')
        const candidateIndex = candidatesIds?.findIndex(({ id }: { id: number }) => id === candidate?.id)

        if (!location?.state?.fromSearch) {
            await getUpdatedCandidatesIds()
        }
        
        if (candidatesIds?.length === 1 || !candidatesIds?.length) {
            if (location?.state?.fromSearch) {
                navigate(`/search${location.state?.search}`)
            } else {
                navigate(`/jobs/${candidate?.jobId}/candidates?hiringStageId=${candidate?.pipelineStage?.id}`);
                dispatch(setActiveTab(candidate?.pipelineStage?.name))
                dispatch(setCandidatesFilter({ ...candidatesFilter, hiringStageId: candidate?.pipelineStage?.id }));
            }
        } else if (candidateIndex === candidatesIds?.length - 1) {
            const prevCandidate = candidatesIds[candidateIndex - 1]?.id;
            navigate(`/jobs/${jobId}/candidates/${prevCandidate}`, { state: { ...location?.state }, replace: true });
        } else {
            const nextCandidate = candidatesIds[candidateIndex + 1]?.id;
            navigate(`/jobs/${jobId}/candidates/${nextCandidate}`, { state: { ...location?.state }, replace: true });
        }
    }

    return {
        handleCandidateNavigate
    };
};